import { useEffect } from "react";
import api from "@/lib/api";

const HEARTBEAT_MS = 45000;

// Keeps this staff member's last_active_at fresh while the admin dashboard is open, so the
// public chat widget's presence indicator (useChatPresence) reflects that someone's around.
export function useStaffHeartbeat(user) {
  useEffect(() => {
    if (!user) return;
    const ping = () => api.put("/admin/presence/heartbeat").catch(() => {});
    ping();
    const interval = setInterval(ping, HEARTBEAT_MS);
    return () => clearInterval(interval);
  }, [user]);
}
